export default __webpack_public_path__ + "static/media/Duck-Egg-Blue.03047dad.jpg";